import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import './Hero.css';

const terminalLines = [
    { text: '$ initiating_security_scan', className: 'text-green-400' },
    { text: 'Scanning system for vulnerabilities...', className: '' },
    { text: '! Multiple security risks detected', className: 'text-yellow-400 mt-2' },
    { text: '! Critical vulnerabilities found', className: 'text-red-500' },
    { text: 'Recommended action:', className: 'mt-2' },
    { text: 'Contact SiberLab ID security solutions', className: 'text-red-500 font-semibold' },
];

const Hero = () => {
    const [currentLine, setCurrentLine] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [linesToShow, setLinesToShow] = useState([]);

    useEffect(() => {
        if (currentLine < terminalLines.length) {
            const lineText = terminalLines[currentLine].text;

            if (charIndex < lineText.length) {
                const timeout = setTimeout(() => {
                    setCharIndex((prev) => prev + 1);
                }, 50); // Typing speed
                return () => clearTimeout(timeout);
            } else {
                const timeout = setTimeout(() => {
                    setLinesToShow((prev) => [...prev, lineText]);
                    setCurrentLine((prev) => prev + 1);
                    setCharIndex(0);
                }, 500); // Delay between lines
                return () => clearTimeout(timeout);
            }
        } else {
            // When done, wait 5s, then reset
            const resetTimeout = setTimeout(() => {
                setCurrentLine(0);
                setCharIndex(0);
                setLinesToShow([]);
            }, 5000);
            return () => clearTimeout(resetTimeout);
        }
    }, [charIndex, currentLine]);

    return (
        <section id="home" className="bg-gradient-to-r from-red-900 to-black text-white min-h-[80vh] flex items-center px-6 md:px-16 py-20">
            <div className="w-full flex flex-col md:flex-row items-start gap-12" data-aos="fade-up" data-aos-duration="1000">


                {/* Left Content */}
                <div className="basis-3/5">
                    <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
                        Secure Your
                        Digital Future <br />
                        with <span className="text-red-500">SiberLab ID</span>
                    </h1>
                    <p className="text-gray-300 max-w-l mb-6">
                        Comprehensive cybersecurity solutions for businesses and individuals.
                        Train, defend, and learn with Indonesia's premier cybersecurity experts.
                    </p>
                    <div className="flex gap-4">
                        <Link
                            to="services"
                            smooth={true}
                            offset={-20}
                            duration={500}
                            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2 rounded inline-block cursor-pointer"
                        >
                            Explore Services
                        </Link>
                        <Link
                            to="contact"
                            smooth={true}
                            offset={-20}
                            duration={500}
                            className="border border-red-600 hover:bg-red-700 hover:text-white text-red-400 font-semibold px-5 py-2 rounded inline-block cursor-pointer"
                        >
                            Contact Us
                        </Link>
                    </div>
                </div>

                {/* Right Side - Terminal UI */}
                <div className="basis-2/5 bg-black text-left text-xs md:max-w-l md:text-xl p-6 rounded-lg shadow-lg border border-gray-700 font-mono">
                    <div className="flex gap-2 mb-2">
                        <div className="w-3 h-3 bg-red-500 rounded-full" />
                        <div className="w-3 h-3 bg-yellow-500 rounded-full" />
                        <div className="w-3 h-3 bg-green-500 rounded-full" />
                    </div>
                    {linesToShow.map((line, i) => (
                        <p key={i} className={terminalLines[i].className}>
                            {line}
                        </p>
                    ))}
                    {currentLine < terminalLines.length && (
                        <p className={`${terminalLines[currentLine].className} typewriter`}>
                            {terminalLines[currentLine].text.slice(0, charIndex)}
                        </p>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Hero;
